import { useEffect } from 'react';

export const useOuterClickNotifier = (onOuterClick: (e: MouseEvent) => void, innerRef: React.MutableRefObject<any>): void => {
  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (innerRef.current && !innerRef.current.contains(e.target)) {
        onOuterClick(e);
      }
    }

    document.addEventListener('click', handleClick);

    return () => document.removeEventListener('click', handleClick);
  }, [onOuterClick]);
};
